import React from 'react';
import {getStrValue} from '../../../store/utility';
import { FormGroup } from 'react-bootstrap';

export default class RequestTab extends React.Component {
    render () {
        return (
            <FormGroup>
                <textarea rows="10" className="form-control note-editor" disabled value={getStrValue(this.props.requestResume)}></textarea>
            </FormGroup>
        )
    }
}




// WEBPACK FOOTER //
// ./src/containers/Request/Tab/RequestTab.js